import React, { useEffect, useState } from 'react'
import { NavigationContextProvider, Texto } from '@gravitate-js/excalibrr'
import { useSecurityContext } from './SecurityContext'
import { Outlet, useLocation } from 'react-router-dom'
import { pageConfig } from './_pageConfig'
import { UserControlPanel } from '@components/_SiteWide/Navigation/ControlPanel/UserControlPanel'
import ReactGA from 'react-ga'
import { Alert } from 'antd'
import { ToolFilled } from '@ant-design/icons'
import { useUserSettings } from '@hooks/settings'
export const Default = () => {
  const { getScopes, handleLogout } = useSecurityContext()
  const location = useLocation()
  const [testingStory, setTestingStory] = useState()
  const { updateSetting } = useUserSettings()

  useEffect(() => {
    ReactGA.pageview(location.pathname)
  }, [location.pathname])

  useEffect(() => {
    const url = window.location.href
    const shouldShowTestBanner = url.includes('test.bb') || url.includes('dev.bb')

    if (shouldShowTestBanner) {
      fetch(`/meta.json`)
        .then(async (response) => response.json())
        .then((meta) => {
          setTestingStory(meta.testingStory)
        })
        .catch((err) => {})
    }
  })

  const updatePreference = (key, value) => {
    updateSetting(key, value)
  }

  return (
    <>
      {testingStory && <TestingBanner testingStory={testingStory} />}

      <NavigationContextProvider
        getScopes={getScopes}
        handleLogout={handleLogout}
        pageConfig={pageConfig}
        userControlPane={<UserControlPanel />}
        updatePreferenceSetting={updatePreference}
      >
        <Outlet />
      </NavigationContextProvider>
    </>
  )
}
const TestingBanner = ({ testingStory }) => {
  return (
    <Alert
      showIcon={false}
      message={
        <Texto align='center' appearance='white' category='h6'>
          <ToolFilled className='pr-2' /> Currently Testing{' '}
          <a
            style={{ color: 'white', fontWeight: 'bold', textDecoration: 'underline' }}
            target='_blank'
            href={`https://gravitatedxp.atlassian.net/jira/software/c/projects/KB/issues/${testingStory}`} rel="noreferrer"
          >
            {testingStory}
          </a>
        </Texto>
      }
      style={{ backgroundColor: 'var(--theme-warning)' }}
      banner
      type='warning'
    />
  )
}
